import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { api } from "../utils/api";

export default function JoinTeam() {
  const { token } = useParams<{ token: string }>();
  const navigate = useNavigate();
  const [status, setStatus] = useState<"joining" | "success" | "error">("joining");
  const [message, setMessage] = useState("");

  useEffect(() => {
    if (!token) return;
    api<{ status: string; teamName: string }>(`/api/teams/join/${token}`, { method: "POST" })
      .then((res) => {
        setStatus("success");
        setMessage(`Joined ${res.teamName}!`);
        setTimeout(() => navigate("/"), 2000);
      })
      .catch((err) => {
        setStatus("error");
        setMessage(err.message || "This invite link is invalid or expired. Ask your team admin for a new one.");
      });
  }, [token, navigate]);

  return (
    <div style={{
      minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center",
      background: "var(--ink-0)", fontFamily: "var(--font-body)",
    }}>
      <div style={{ textAlign: "center" }}>
        {status === "joining" && (
          <>
            <div className="spinner spinner-lg" style={{ margin: "0 auto 1rem" }} />
            <p style={{ color: "var(--text-secondary)" }}>Joining team…</p>
          </>
        )}
        {status === "success" && (
          <>
            <h2 style={{ color: "var(--flag-green)", fontFamily: "var(--font-display)", letterSpacing: "-0.04em" }}>{message}</h2>
            <p style={{ color: "var(--text-secondary)", marginTop: "0.5rem" }}>Redirecting to dashboard…</p>
          </>
        )}
        {status === "error" && (
          <>
            <h2 style={{ color: "var(--flag-red)", fontFamily: "var(--font-display)", letterSpacing: "-0.04em" }}>Couldn't join team</h2>
            <p style={{ color: "var(--text-secondary)", marginTop: "0.5rem" }}>{message}</p>
            <button className="btn btn-primary" onClick={() => navigate("/login")} style={{ marginTop: "1rem" }}>
              Go to login
            </button>
          </>
        )}
      </div>
    </div>
  );
}
